let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lzpdB")).then(() => parcelRequire('dPQzM'));